import { useQuery } from "@tanstack/react-query";
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import type { PartnerWalletDetails } from "../utils/asset-config";

export const PUBLIC_WALLET_DETAILS_KEY = ["public-wallet-details"];

const usePublicWalletDetails = () => {
  const axiosInstance = useAuthAxios();

  return useQuery<PartnerWalletDetails>({
    queryKey: PUBLIC_WALLET_DETAILS_KEY,
    queryFn: async () => {
      const res = await axiosInstance.get(API.publicWalletDetails);
      return res.data?.data ?? {};
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    retry: 2,
  });
};

export default usePublicWalletDetails;
